<template>
    <flex-layout>
        <ServiceShowListModal/>
        <page-header heading="Service Show List" action="Add" toggle="offcanvas" target="#offcanvasCreate" :guard="this.$route.meta.guard"
            @click="setCreateForm" />

        <ServiceShowListTable  :tableHeading="tableHeading"/>
    </flex-layout>
</template>
  
<script>
import FlexLayout from "@/components/Layout/FlexLayout.vue";
import ServiceShowListTable from "@/components/ServiceShowList/table.vue";
import PageHeader from "@/components/Utility/PageHeader.vue";
import ServiceShowListModal from "@/components/ServiceShowList/modal.vue";
export default {
    name: "ServiceShowList",
    components: {
        // AbsoluteLayout,
        PageHeader,
        FlexLayout,
        ServiceShowListTable,
        ServiceShowListModal
    },
    data() {
        return {
            tableHeading: [
                {
                    heading: "Title",
                },
                {
                    heading: "Description",
                },
                {
                    heading: "Image",
                },
                {
                    heading: "Status",
                },
            ],
        };
    },
    methods: {
        setCreateForm() {
            this.$root.$emit('CREATE');
        },
    }
};
</script>
  